<template>
  <div class="ourServices">
    <div class="ourServices__row">
      <div
        class="ourServices__box ourServices__1"
        v-for="(service, index) in services"
        :key="index"
      >
        <router-link to="/services" class="ourServices-anchor">
          <i :class="['fa-3x', 'my-4', 'ourServices__color', service.icon]"></i>
          <h4>{{ service.title }}</h4>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurServices",
  data() {
    return {
      services: [
        { title: "Dedicated Lines (DL)", icon: "fas fa-server" },
        { title: "Business Broadband (BB)", icon: "fas fa-network-wired" },
        { title: "Wireless Connects (XC)", icon: "fas fa-wifi" },
      ],
    };
  },
};
</script>

<style scoped>
.ourServices {
  padding: 5rem;
  color: #000;
}

.ourServices__row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap; 
  gap: 2rem;
}

.ourServices__box {
  background-color: #f5f5f5;
  width: 300px;
  text-align: center;
  padding: 2rem;
  border-radius: 15px;
  transition: all 0.3s ease-in-out;
  color: #000;
}

.ourServices__box:hover {
  transform: scale(1.1);
  color: #fff;
}

.ourServices__1:hover {
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)),
    url('../assets/images/Eu1wHdk.jpg');
  background-size: cover;
  background-blend-mode: overlay;
  object-position: 50% 50%;
}

.ourServices__1:nth-child(2):hover {
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)),
    url('../assets/images/tV9BDv2.jpg');
  background-size: cover;
  background-blend-mode: overlay;
  object-position: 50% 50%;
}

.ourServices__1:nth-child(3):hover {
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)),
    url('../assets/images/M3Ihnbo.jpg');
  background-size: cover;
  background-blend-mode: overlay;
  object-position: 50% 50%;
}

.ourServices-anchor {
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease-in-out;
}

.ourServices-anchor:hover {
  color: #fff;
}

.ourServices__color {
  color: #007bff;
}

.ourServices__color:hover {
  color: #fff;
}

@media (max-width: 768px) {
  .ourServices {
    padding: 2rem;
  }

  .ourServices__row {
    flex-direction: column;
    align-items: center;
  }
}
</style>
